import * as apiKey from './apiKey';
import * as auth from './auth';
import * as automation from './automation';
import * as batch from './batch';
import * as billing from './billing';
import * as bookmark from './bookmark';
import * as bundle from './bundle';
import * as business from './business';
import * as cards from './cards';
import * as channel from './channel';
import * as chat from './chat';
import * as dashboard from './dashboard';
import * as entity from './entity';
import * as _export from './export';
import * as importData from './importData';
import * as thread from './thread';
import * as user from './user';
import * as viewTemplate from './viewTemplate';
import * as workflow from './workflow';

/*
    In the shared components API layer, we try to make the business logic code as clean
    as possible. Therefore we have multiple params in the query instead of just passing
    in a mysterious "input" prop to variables.

    This:
    { variables: { id, ...update } }

    is nicer than this:
    { variables: { input: { id, ...update} } }

*/

export const Mutations = {
  apiKey,
  auth,
  batch,
  billing,
  bookmark,
  bundle,
  business,
  cards,
  channel,
  chat,
  dashboard,
  entity,
  _export,
  automation,
  importData,
  thread,
  user,
  viewTemplate,
  workflow,
};
